import { request } from '@umijs/max';
import { saveWorkspaceIdList, type MemberWorkspace } from '@/utils/memberWorkspaceCache';

const SUCCESS_CODE = 200;

export type ResultResponse<T> = {
  code: number;
  message?: string;
  data?: T;
};

export type MemberInfo = {
  id: number;
  workspaceIdList?: MemberWorkspace[];
  /** 兼容旧字段名 */
  memberWorkspaceList?: MemberWorkspace[];
};

export function resolveWorkspaceIdList(info: MemberInfo): MemberWorkspace[] {
  return info.workspaceIdList ?? info.memberWorkspaceList ?? [];
}

export function memberInfoToCurrentUser(info: MemberInfo): API.CurrentUser {
  const workspaceIdList = resolveWorkspaceIdList(info);
  const firstWorkspaceName = workspaceIdList[0]?.name;
  const displayName = firstWorkspaceName || `member-${info.id}`;
  return {
    userid: String(info.id),
    memberId: info.id,
    name: displayName,
    workspaceIdList,
    memberWorkspaceList: workspaceIdList,
  };
}

/** 获取当前会员信息 GET /app/member/info */
export async function fetchMemberInfo(
  options?: { [key: string]: unknown },
): Promise<MemberInfo> {
  try {
    const res = await request<ResultResponse<MemberInfo>>('/app/member/info', {
      method: 'GET',
      skipErrorHandler: true,
      ...(options || {}),
    });
    if (res?.code !== SUCCESS_CODE || !res.data) {
      throw new Error(res?.message?.trim() || '获取会员信息失败');
    }
    saveWorkspaceIdList(resolveWorkspaceIdList(res.data));
    return res.data;
  } catch (error: unknown) {
    const data = (error as { response?: { data?: ResultResponse<MemberInfo> } })?.response?.data;
    if (data?.message) {
      throw new Error(data.message);
    }
    if (error instanceof Error && error.message) {
      throw error;
    }
    throw new Error('获取会员信息失败');
  }
}
